var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.243 3.02206C10.5534 3.02206 9.1836 4.26951 9.1836 5.80833V7.66584H7.14398V5.80833C7.14398 3.24364 9.4269 1.16455 12.243 1.16455C15.0592 1.16455 17.3421 3.24364 17.3421 5.80833V7.66584H15.3024V5.80833C15.3024 4.26951 13.9327 3.02206 12.243 3.02206Z",
    fill: "#F28520"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12427 7.66602L4.08466 9.83311V20.6685L6.12427 22.8357H18.362L20.4017 20.6685V9.83311L18.362 7.66602H6.12427ZM6.12427 20.6685V9.83311H18.362V20.6685H6.12427Z",
    fill: "#3360AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2435 18.0566C13.65 18.0566 14.7902 16.8452 14.7902 15.3508C14.7902 13.8564 13.65 12.645 12.2435 12.645C10.8371 12.645 9.6969 13.8564 9.6969 15.3508C9.6969 16.8452 10.8371 18.0566 12.2435 18.0566Z",
    fill: "#EA1763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock2);
export default __webpack_public_path__ + "static/media/lock-2.c7240c553ea4f6e2330f17f56c6844c9.svg";
export { ForwardRef as ReactComponent };